<div class="obg-m-latest-privacy-policy-container">
	<p class="obg-m-latest-privacy-policy-container-title" [innerHtml]="'privacy-policy.updated-title' | translate"></p>
	<ng-container
		*ngIf="showError;
			then privacyPolicyAcceptError
			else privacyPolicyUpdatedContent"
	>
	</ng-container>
</div>

<ng-template #privacyPolicyUpdatedContent>
	<article class="obg-m-latest-privacy-policy-container-content">
		<p [innerHtml]="'privacy-policy.updated-description' | translate"></p>
	</article>
	<div class="obg-m-latest-privacy-policy-container-options">
		<ng-container
			*ngIf="isDesktop;
				then desktopCta
				else mobileCta"
		>
		</ng-container>
	</div>
</ng-template>

<ng-template #privacyPolicyAcceptError> {{ 'privacy-policy.update-error' | translate }} </ng-template>

<ng-template #desktopCta>
	<button mat-flat-button color="accent" test-id="latest-privacy-policy-accept" (click)="accept()">
		{{ 'privacy-policy.updated-accept' | translate }}
	</button>
</ng-template>

<ng-template #mobileCta>
	<button mat-button color="primary" test-id="latest-privacy-policy-accept" (click)="accept()">
		{{ 'privacy-policy.updated-accept' | translate }}
	</button>
</ng-template>
